<template> 
    <b-card no-body>
        <b-card-header class="border-0 bgc-f7">
            <b-row>
                <b-col class="text-right">
                <base-button type="primary" icon size="sm" @click="$router.go(-1)">
                    <span class="btn-inner--text">Back</span>
                </base-button>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col class="main-title text-center">
                <h1 class="mb-0">Our Projects</h1>
                </b-col>
            </b-row>
            <b-row class="justify-content-center">
                <b-col cols="12" md="3" lg="3">
                <div class="p-2">
                    <base-input
                        v-model="search"
                        prepend-icon="fas fa-search"
                        placeholder="Search">
                    </base-input>
                </div>
                </b-col>
            </b-row>
        </b-card-header>
        <section id="property-listing">
            <div class="container pb-4">
                <b-row v-if="!is_loading">
                    <b-col cols="12" md="4" class="mb-3 mt-3" v-for="(project, index) in filteredProjects" :key="index">
                        <div class="card cursor-pointer h-100 mb-3" @click="viewProject(project)">
                            <img class="card-img-top p-0 m-0" style="height:230px;object-fit: cover" :src="project.project_cover_image" :alt="project.project_name" v-if="project.project_cover_image">
                            <div class="card-img-top" style="height:230px;background-color: #252938;" v-else></div>
                            <div class="card-body pt-3 pb-3">
                                <b-row>
                                    <b-col cols="12">
                                        <span class="badge badge-warning text-dark" v-if="project.project_stage_id === 1">Under Construction</span>
                                        <span class="badge badge-info text-dark" v-else-if="project.project_stage_id === 3">Sub Sale</span>
                                        <span class="badge badge-dark text-white" v-else-if="project.project_stage_id === 4">For Rent</span>
                                        <span class="badge badge-success text-dark" v-else>Completed</span>
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <small class="text-muted">{{ project.project_type }}</small>
                                            <div class="text-primary cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144a31.76 31.76 0 0 0-34.4-5.4"/></svg>
                                                <span class="text-xs ml-1">Share</span>
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col cols="12">
                                        <h3 class="card-title mb-1">{{ project.project_name }}</h3>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 384 512"><path fill="currentColor" d="M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0M192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128"/></svg>
                                        <el-tooltip :content="project.project_location">
                                            <span class="text-xs">
                                                {{ project.project_location || 'N/A' | shortenText(35) }}
                                            </span>
                                        </el-tooltip>
                                        <div v-if="project.unit_lowest && project.unit_lowest.listing_price" class="mb-2">
                                            <span class="text-lg font-weight-600">From RM {{ project.unit_lowest.listing_price | moneyFormatter }}</span>
                                        </div>
                                        <div v-else class="mb-2">
                                            <span class="text-lg font-weight-600">N/A</span>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" class="d-flex text-muted" v-if="project.unit_highest">
                                         <div class="d-flex align-items-center mr-3">
                                            <span class="text-xs">{{ project.unit_highest.unit_type.bedroom }}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="16" height="16" viewBox="0 0 56 56"><path fill="currentColor" d="M5.29 21.994h5.613v-3.179c0-2.064 1.16-3.178 3.248-3.178h8.235c2.088 0 3.248 1.114 3.248 3.178v3.178h5.01v-3.178c0-2.064 1.16-3.178 3.364-3.178h7.725c2.204 0 3.364 1.114 3.364 3.178v3.178h5.614V15.66c0-4.106-2.18-6.193-6.17-6.193H11.46c-3.967 0-6.17 2.087-6.17 6.193ZM0 44.867c0 1.137.742 1.856 1.902 1.856h1.3c1.136 0 1.878-.72 1.878-1.856v-3.294c.255.07.998.116 1.531.116h42.8c.534 0 1.254-.047 1.509-.116v3.294c0 1.137.742 1.856 1.879 1.856h1.322c1.137 0 1.879-.72 1.879-1.856v-13.2c0-4.199-2.343-6.495-6.588-6.495H6.588C2.343 25.172 0 27.468 0 31.667Z"/></svg>
                                        </div>
                                        <div class="d-flex align-items-center mr-3">
                                            <span class="text-xs">{{ project.unit_highest.unit_type.bathroom }}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M96 77.3C96 70 101.9 64 109.3 64c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9c-3.6 9-5.6 18.9-5.6 29.2 0 19.9 7.2 38 19.2 52-5.3 9.2-4 21.1 3.8 29 9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5l-14.9-14.9C149.4 8.1 129.7 0 109.3 0 66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H96zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h256v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-40.4c19.6-17.6 32-43.1 32-71.6v-16z"/></svg>
                                        </div>
                                        <div class="d-flex align-items-center mr-3">
                                            <span class="text-xs">{{ project.unit_highest.unit_type.car_park }}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M135.2 117.4 109.1 192h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4m-95.6 79.4L74.8 96.3C88.3 57.8 124.6 32 165.4 32h181.2c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-48H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-26.7 16.4-49.6 39.6-59.2M128 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64"/></svg>
                                        </div>
                                        <div class="d-flex align-items-center mr-3">
                                            <span class="text-xs me-1" v-if="project.unit_lowest.built_up === project.unit_highest.built_up">
                                                {{ project.unit_lowest.built_up | fixNumberFormat }} sqft
                                            </span>
                                            <span class="text-xs me-1" v-else>
                                                {{ project.unit_lowest.built_up | fixNumberFormat }} - {{ project.unit_highest.built_up | fixNumberFormat }} sqft
                                            </span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M.2 468.9C2.7 493.1 23.1 512 48 512h416c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-48v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-64h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 1.7.1 3.3.2 4.9"/></svg>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" class="d-flex align-items-center justify-content-between mt-2">
                                        <span class="text-muted text-sm">{{ project.project_developer }}</span>
                                        <div class="text-primary">
                                            <span class="text-xs mr-1" >{{ project.unit_total }} units</span>
                                            <el-tooltip effect="light" placement="top" popper-class="p-0 m-0">
                                                <template #content>
                                                    <b-table-simple borderless>
                                                        <b-tbody>
                                                            <b-tr>
                                                                <b-td>
                                                                    <span class="text-xs" :style="{'color': UNIT_COLOR['Open']}">Open</span>
                                                                    <p class="mr-3">{{ project.counts.units_open }}</p>
                                                                </b-td>
                                                                <b-td>
                                                                    <span class="text-xs" :style="{'color': UNIT_COLOR['Reserved']}">Reserved</span>
                                                                    <p class="mr-3">{{ project.counts.units_reserved }}</p>
                                                                </b-td>
                                                                <b-td>
                                                                    <span class="text-xs" :style="{'color': UNIT_COLOR['Booked']}">Booked</span>
                                                                    <p>{{ project.counts.units_booked }}</p>
                                                                </b-td>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-td>
                                                                    <span class="text-xs" :style="{'color': UNIT_COLOR['Locked']}">Locked</span>
                                                                    <p class="mr-3">{{ project.counts.units_locked }}</p>
                                                                </b-td>
                                                                <b-td>
                                                                    <span class="text-xs" :style="{'color': UNIT_COLOR['Sold']}">Sold</span>
                                                                    <p class="mr-3">{{ project.counts.units_sold }}</p>
                                                                </b-td>
                                                                <b-td>
                                                                    <span class="text-xs" :style="{'color': UNIT_COLOR['Not Available']}">Not Available</span>
                                                                    <p>{{ project.counts.units_not_available }}</p>
                                                                </b-td>
                                                            </b-tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </template>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64"/></svg>
                                            </el-tooltip>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="card-footer text-right py-2">
                                <span class="text-muted text-xs">
                                    Listed on: 
                                    {{ project.project_listed_date | dateFormatString }}
                                </span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="text-center" v-else>
                    <el-button type="text" :loading="is_loading">Loading projects ...</el-button>
                </div>
            </div>
        </section>
    </b-card>
</template>
<script>
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import { Tooltip, Button } from 'element-ui'
import {UNIT_COLOR} from '@/assets/js/colors.js'

export default {
    mixins: [notifyFunctionMixin],
    components: {
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
    },
    data(){
        return{
            UNIT_COLOR:UNIT_COLOR,
            is_loading: false,
            search: '',
            projects: [],
        }
    },
    created(){
        this.getPMPProjects()
    },
    computed:{
        filteredProjects(){
            if (this._gAuth.appCode() === 'vps-v2') {
                return this.projects.filter(project => project.project_source_type !== 'PMP');
            }
          return this.projects.filter(project => project.project_name.toLowerCase().includes(this.search.toLowerCase()))
        },
    },
    methods:{
        viewProject(project) {
            if (project.project_source_type) {
                this.$router.push({
                    path: `/propertyListing/${project.project_id}`,
                    query: { source_type: project.project_source_type }
                })
            } else {
                this.$router.push({
                    path: `/propertyListing/${project.project_id}`,
                    query: { source_type: 'PMP' }
                })
            }
        },
        getPMPProjects(){
            this.is_loading = true
            axios.get(services.lookup + 'pmp/projects?ver=2', {headers: getHeader()})
                .then(res=>{
                    this.is_loading = false
                    this.projects = res.data.data
                })
                .catch(e => {
                    this.is_loading = false
                    this.errorFunction(e)
                })
        }
    }
};
</script>